import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SettingsPhoneIcon from '@mui/icons-material/SettingsPhone';
import { connect } from 'react-redux';
import {

    FormInput
} from '../ConfigFunctions/configElements';

import { mapStateToProps } from '../models/buscar';

function SimpleAccordion(props) {

   const  anexosAmbos = props.rightAnexos.concat(props.leftAnexos);
    const [solicitadas] = React.useState([])

  

   






    return (
        <div>

            {anexosAmbos.map((solicitud, idx) => {
                return (

                    <Accordion >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            style={{ backgroundColor: solicitadas.includes(solicitud.name) ? 'rgba(238, 238, 238, 1)' : null }}
                        >
                            {/* <Typography>
                                {solicitud.name}
                            </Typography> */}

                            <SettingsPhoneIcon style={{width: 15, marginLeft: 30}}/>
                            
                            <Typography style={{marginLeft: 20}}>
                                {solicitud}
                            </Typography>

                            {solicitud.status === "In" ?
                                <Typography style={{
                                    marginLeft: 20, fontSize: 10, alignItems: 'center', justifyContent: 'center',
                                    backgroundColor: '#22A277', borderRadius: 10, padding: 5, color: 'lightgrey'
                                }}>
                                    En línea
                                </Typography> : null}

                        </AccordionSummary>
                        <AccordionDetails >
                            <Typography >
                                {solicitud.text}
                            </Typography>

                            {solicitud.name === "Desvío de llamadas" ?
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                    <FormInput
                                        placeholder='Número de desvío'
                                        type="text"
                                        name="desciption"
                                        style={{ backgroundColor: 'rgba(238, 238, 238, 0.9)', marginLeft: 0 }}

                                    />

                                    <FormInput
                                        placeholder='Información de desvío'
                                        type="text"
                                        name="desciption"
                                        style={{ backgroundColor: 'rgba(238, 238, 238, 0.9)', marginLeft: 10 }}

                                    />
                                </div> : null}



                            {solicitud.name === "Transferencias de llamadas" ?
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                    <FormInput
                                        placeholder='Número de transferencia'
                                        type="text"
                                        name="desciption"
                                        style={{ backgroundColor: 'rgba(238, 238, 238, 0.9)', marginLeft: 0 }}

                                    />

                                </div> : null}

                            {solicitud.name === "Llamada en espera" ?
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                    <FormInput
                                        placeholder='Agrega un mensaje de fondo personalizado'
                                        type="text"
                                        name="desciption"
                                        style={{ backgroundColor: 'rgba(238, 238, 238, 0.9)', marginLeft: 0 }}

                                    />

                                </div> : null}

                            <div style={{
                                height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', alignContent: 'center',
                                borderTopLeftRadius: 5, borderTopRightRadius: 5, paddingLeft: 20, paddingTop: 20
                            }}>

                                

                            </div>
                        </AccordionDetails>
                    </Accordion>

                )
            })}
        </div>
    );
}


  export default connect(mapStateToProps, null)(SimpleAccordion);